import { render } from "./MeasureDefinitionQueryCard.vue?vue&type=template&id=2d8e3a16&scoped=true&ts=true"
import script from "./MeasureDefinitionQueryCard.vue?vue&type=script&lang=ts"
export * from "./MeasureDefinitionQueryCard.vue?vue&type=script&lang=ts"

import "./MeasureDefinitionQueryCard.vue?vue&type=style&index=0&id=2d8e3a16&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d8e3a16"]])

export default __exports__